<template>
    <Card>
        <template v-slot:title>
            <h5>Incident</h5>
        </template>

        <template v-slot:content>
            <div class="container mx-2">
                <div class="row">
                    <div class="col-left">Incident No:</div>
                    <div class="col-right">
                        <span>{{ incident.incident_number ?? 'N/A' }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-left text-bold">Category:</div>
                    <div class="col-right">
                        <span>{{ incident.incident_category ?? 'N/A' }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-left text-bold">Incident Date:</div>
                    <div class="col-right">
                        <span>{{ incident && incident.incident_date ? formatDate(incident.incident_date) : 'N/A' }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-left text-bold">Callsign:</div>
                    <div class="col-right">
                        <span>{{ appliance.name ?? 'N/A' }}</span>
                    </div>
                </div>
            </div>
            <div>
                <Accordion :multiple="true" :activeIndex="[0]" class="incidentTab mt-3">
                    <AccordionTab header="Incident Details">
                        <div class="row">
                            <div class="col-left text-bold">Incident Type:</div>
                            <div class="col-right">
                                <span>{{ incident.type ?? 'N/A' }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-left text-bold">Incident Location:</div>
                            <div class="col-right">
                                <span>{{ incident.location ?? 'N/A' }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-left text-bold">Incident Call Time:</div>
                            <div class="col-right">
                                <!-- we dont have anything at the moment -->
                                <span>N/A</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-left text-bold">Incident OiC:</div>
                            <div class="col-right">
                                <!-- we dont have anything at the moment -->
                                <span>N/A</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-left text-bold">Incident Details:</div>
                            <div class="col-right">
                                <span v-html="incident.details ?? 'N/A'"></span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-left text-bold">Incident Station:</div>
                            <div class="col-right">
                                <span>{{ incident.station ?? 'N/A' }}</span>
                            </div>
                        </div>
                    </AccordionTab>
                </Accordion>
            </div>
        </template>
    </Card>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { onUnmounted } from 'vue';
import { applianceStore, incidentStore } from '../../../../../store/global-stores';
import { formatDate } from '@/utilities/date-formatter';

const { incident } = storeToRefs(incidentStore);
const { appliance } = storeToRefs(applianceStore);

onUnmounted(() => {
    incidentStore.initIncidentForm();
    applianceStore.initAppliance();
});
</script>
